import { z } from 'zod/v4';

import { foldSynonyms, isString, normalizeFlatArgs } from '../widget-schemas/fold-helpers';

export const COLUMN_ID_SYNONYM_KEYS = ['id', 'column_id'] as const;

const removeColumnObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to remove.'),
});

/**
 * Structural remove/reorder args live here alongside the other `structure-schemas/` (block, column
 * create/update) rather than under `widget-schemas/`. No `data` field, so the flat-args normalizer
 * applies instead of `normalizeWidgetArgs`.
 */
export const removeColumnArgsSchema = z.preprocess(
    (raw) => normalizeFlatArgs(raw, (args) => foldSynonyms(args, args, 'columnId', COLUMN_ID_SYNONYM_KEYS, isString)),
    removeColumnObjectSchema
);
